import { render, staticRenderFns } from "./About-left.vue?vue&type=template&id=822d42d0&scoped=true"
import script from "./About-left.vue?vue&type=script&lang=js"
export * from "./About-left.vue?vue&type=script&lang=js"
import style0 from "./About-left.vue?vue&type=style&index=0&id=822d42d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822d42d0",
  null
  
)

export default component.exports